export const getDoctorImageSrc = (base64Image) => {
  if (!base64Image || base64Image.trim() === "") {
    return "/doctor-dummy.png";
  }

  return `data:image/jpeg;base64,${base64Image}`;
};
